export default __webpack_public_path__ + "static/media/plantWateringGallery.c8d51159.jpg";